/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { changeStyleWithHosting } from "utility/hosting";

import type { FC } from "react";

export const ResaleApplicationCreditCardInputs: FC = () => {
  const { t } = useI18n();
  const classes = styles();

  return (
    <div css={classes.root}>
      <label css={classes.inputGroup}>
        <span>{t("event.resale.entry.confirmation.cardNumber")}</span>
        <input
          type="text"
          name="cardNumber"
          autoComplete="cc-number"
          inputMode="numeric"
          minLength={14}
          maxLength={16}
          pattern="[0-9]{14,16}"
          placeholder="1234123412341234"
          required
          css={classes.textInput}
        />
      </label>

      <img
        src="/images/liveCommerce/paymentMethodCard.png"
        alt=""
        aria-hidden="true"
        css={classes.cardBrands}
      />

      <fieldset css={classes.inputGroup}>
        <legend>
          {t("event.resale.entry.confirmation.cardExpirationDate")}
        </legend>
        <div css={classes.expirationInputs}>
          <input
            type="text"
            name="cardExpireMonth"
            aria-label={t(
              "event.resale.entry.confirmation.cardExpirationMonth"
            )}
            autoComplete="cc-exp-month"
            inputMode="numeric"
            minLength={2}
            maxLength={2}
            pattern="(0[1-9]|1[0-2])"
            placeholder="MM"
            required
            css={[classes.textInput, classes.expirationInput]}
          />
          <input
            type="text"
            name="cardExpireYear"
            aria-label={t("event.resale.entry.confirmation.cardExpirationYear")}
            autoComplete="cc-exp-year"
            inputMode="numeric"
            minLength={2}
            maxLength={2}
            pattern="[0-9]{2}"
            placeholder="YY"
            required
            css={[classes.textInput, classes.expirationInput]}
          />
        </div>
      </fieldset>

      <label css={classes.inputGroup}>
        <span>{t("event.resale.entry.confirmation.cardholderName")}</span>
        <input
          type="text"
          name="cardHolderName"
          autoCapitalize="characters"
          autoComplete="cc-name"
          pattern="[A-Za-z ]+"
          placeholder="TARO YAMADA"
          required
          spellCheck={false}
          css={classes.textInput}
        />
      </label>

      <label css={classes.inputGroup}>
        <span>{t("event.resale.entry.confirmation.cardSecurityCode")}</span>
        <input
          type="password"
          name="cardSecurityCode"
          autoComplete="cc-csc"
          inputMode="numeric"
          minLength={3}
          maxLength={4}
          pattern="[0-9]{3,4}"
          placeholder="123"
          required
          css={[classes.textInput, classes.securityCodeInput]}
        />
      </label>
    </div>
  );
};

const styles = () => {
  const { accentColor } = changeStyleWithHosting().baseStyles;

  return {
    root: css`
      display: grid;
      gap: 20px;
    `,
    inputGroup: css`
      display: grid;
      gap: 8px;
      padding: 0;
      margin: 0;
      color: #222;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.5;
      border: 0;
    `,
    textInput: css`
      &[type="text"],
      &[type="password"] {
        width: 100%;
        height: 52px;
        padding: 0 16px;
        color: #222;
        font-family: inherit;
        font-size: 16px;
        font-weight: normal;
        line-height: 1.5;
        background-color: #fff;
        border: 1px solid #aaa;
        border-radius: 0;
        box-sizing: border-box;
        &::placeholder {
          color: #aaa;
          opacity: 1;
        }
        &:focus-visible {
          border-color: ${accentColor};
          outline: 1px solid ${accentColor};
          outline-offset: 0;
        }
      }
    `,
    cardBrands: css`
      width: 190px;
      height: auto;
    `,
    expirationInputs: css`
      display: flex;
      gap: 12px;
    `,
    expirationInput: css`
      width: 70px;
    `,
    securityCodeInput: css`
      width: 80px;
    `,
  };
};
